export enum PageType {
  MAIN = "MAIN",
  COOKIE_POLICY = "COOKIE_POLICY",
  OUR_PROCESS = "OUR_PROCESS",
  TERMS_OF_USE = "TERMS_OF_USE",
  PRIVACY_POLICY = "PRIVACY_POLICY",
  CONTACT_US = "CONTACT_US",
  NFT_STACKING = "NFT_STACKING",
  GAME_RULES = "GAME_RULES",
  BUY_NFT = "BUY_NFT",
  FOR_INFLUENCERS = "FOR_INFLUENCERS",
  WAX_WALLET = "WAX_WALLET",
}
